import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M14 10C14 11.105 13.105 12 12 12C10.895 12 10 11.105 10 10C10 8.895 10.895 8 12 8C13.105 8 14 8.895 14 10Z"
      fill="currentColor"
    />
    <path
      d="M10.5551 13.083C10.9101 13.293 8.23911 18.447 7.95511 18.925C7.67111 19.403 7.15411 19.62 6.79911 19.409C6.44411 19.198 6.38711 18.64 6.67111 18.162C6.95511 17.685 10.2001 12.873 10.5551 13.083V13.083Z"
      fill="currentColor"
    />
    <path
      d="M18 2H6C4.895 2 4 2.895 4 4V20C4 21.105 4.895 22 6 22H18C19.105 22 20 21.105 20 20V4C20 2.895 19.105 2 18 2ZM6 3C6.552 3 7 3.448 7 4C7 4.552 6.552 5 6 5C5.448 5 5 4.552 5 4C5 3.448 5.448 3 6 3ZM12 16C11.583 16 11.175 15.957 10.782 15.876C10.175 17.26 9.378 18.673 8.854 19.556C8.465 20.211 7.781 20.618 7.07 20.618C6.746 20.618 6.43 20.532 6.156 20.37C5.252 19.832 4.993 18.595 5.577 17.61C5.596 17.579 6.647 15.88 7.838 14.315C6.707 13.225 6 11.696 6 10C6 6.686 8.686 4 12 4C15.314 4 18 6.686 18 10C18 13.314 15.314 16 12 16ZM18 21C17.448 21 17 20.552 17 20C17 19.448 17.448 19 18 19C18.552 19 19 19.448 19 20C19 20.552 18.552 21 18 21ZM18 5C17.448 5 17 4.552 17 4C17 3.448 17.448 3 18 3C18.552 3 19 3.448 19 4C19 4.552 18.552 5 18 5Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'HardDriveFill');

export default Icon;
